<script>
  import { TextField, Icon, DropdownList, DropdownItem } from "@gl/design-system";
  import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
  import {
    getUrlHistory,
    removeUrlFromHistory,
  } from "../services/devProxyHistory";

  export let id;
  export let label = null;
  export let info = null;
  export let placeholder = null;
  export let value = "";
  /** Storage scope for this field's history — kept separate per target/custom rule. */
  export let historyKey;

  let container;
  let open = false;
  let entries = [];

  function refresh() {
    entries = getUrlHistory(historyKey);
  }

  $: needle = (value || "").trim().toLowerCase();
  $: filtered = needle
    ? entries.filter((entry) => entry.toLowerCase().includes(needle))
    : entries;

  function onFocus() {
    refresh();
    open = true;
  }

  function select(url) {
    value = url;
    open = false;
  }

  function remove(url) {
    removeUrlFromHistory(historyKey, url);
    refresh();
  }

  function onWindowClick(event) {
    if (open && container && !container.contains(event.target)) {
      open = false;
    }
  }

  function onKeydown(event) {
    if (event.key === "Escape") open = false;
  }
</script>

<svelte:window on:click={onWindowClick} on:keydown={onKeydown} />

<div class="gl-autocomplete url-history" class:is-focused={open} bind:this={container}>
  <TextField
    bind:value
    {id}
    {label}
    {info}
    {placeholder}
    autocomplete="off"
    on:focus={onFocus}
  />
  {#if open && filtered.length}
    <div class="gl-autocomplete-results">
      <DropdownList opened>
        {#each filtered as url (url)}
          <DropdownItem selectable={false}>
            <div class="url-history-row">
              <button
                type="button"
                class="url-history-value"
                title={url}
                on:mousedown|preventDefault={() => select(url)}
              >
                {url}
              </button>
              <button
                type="button"
                class="url-history-remove"
                title="Remove from history"
                on:mousedown|preventDefault={() => remove(url)}
              >
                <Icon icon={faTrashAlt} />
              </button>
            </div>
          </DropdownItem>
        {/each}
      </DropdownList>
    </div>
  {/if}
</div>

<style>
  .url-history-row {
    align-items: center;
    display: flex;
    gap: var(--gl-spacing-2);
  }

  .url-history-value {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    flex: 1;
    font: inherit;
    min-width: 0;
    overflow: hidden;
    padding: 0;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .url-history-value:hover {
    text-decoration: underline;
  }

  .url-history-remove {
    background: none;
    border: none;
    color: var(--gl-text-light);
    cursor: pointer;
    display: inline-flex;
    flex-shrink: 0;
    padding: 0.15rem;
  }

  .url-history-remove:hover {
    color: var(--gl-error);
  }
</style>
